import Axios from 'axios'
import config from '../config/dev'
import User from "../helpers/user";
import PATH from "../config/dev";

Axios.interceptors.request.use(function (config) {
    document.body.classList.add('loading-body');

    if (!User.isGuest()) {
        config.headers.Authorization = User.getUser().auth_key
    }
    return config
}, function (error) {
    return Promise.reject(error);
});

Axios.interceptors.response.use(function (response) {
    document.body.classList.remove('loading-body');

    return response;
}, function (error) {
    document.body.classList.remove('loading-body');
    if (error.response.status === 401) {
        User.logout()
    }

    if (error.response.status !== 422) {
        alert(
            "Váratlan hiba történt! Kérjük frissítse a böngészőt.\n"
            + 'Ha a hiba továbbra is fennáll, kérjük  vegyefel a kapcsolatot az üzemeltetőkkel!'
        );

        console.log(error);
        api.report(error)
        return false;
    }

    return Promise.reject(error);
});


const api = {

    get(url) {
        return Axios.get(config.ENDPOINT_BASE_URL + url);
    },

    post(url, data) {
        return Axios.post(config.ENDPOINT_BASE_URL + url, data)
    },

    postFile(url, data) {
        return Axios.post(config.ENDPOINT_BASE_URL + url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    delete(url) {
        return Axios.delete(config.ENDPOINT_BASE_URL + url)
    },

    put(url, data) {
        return Axios.put(config.ENDPOINT_BASE_URL + url, data)
    },

    report(error) {
        if (process.env.REACT_APP_SLACK_REPORT_ENABLED) {
            console.log('Slack report is not enabled!');
            return;
        }

        // const data = {
        //     "text": `Name: ${name} \\n${email} \\n${message}`,
        // }

        Axios.post(process.env.REACT_APP_SLACK_REPORT_WEBHOOK_URL, JSON.stringify(error), {
            withCredentials: false,
            transformRequest: [(data) => data]
        })
    },
    downloadFile(url, name) {
        window.open(
            PATH.ENDPOINT_BASE_URL + url
            + '?api_token=' + User.requireUser().auth_key
            + '&name=' + name
        );
    }
}

export default api


// WEBPACK FOOTER //
// ./src/source/api.js